import Vue from 'vue';
import vClickOutside from 'v-click-outside';
import VTooltip from 'v-tooltip';
import VueClipboard from 'vue-clipboard2';
import smoothscroll from 'smoothscroll-polyfill';
import '@/utility/filters';
import App from './App';
import store from './store';
import { gaMixin } from './services/gAnalytics';
import { gTagMixin } from './services/gTag';
import trackEvent from './services/trackEventHandler';
import router from './router';
import DynamicComponent from '@/components/common/DynamicComponent';

Vue.use(vClickOutside);
Vue.use(VTooltip);
Vue.use(VueClipboard);
Vue.mixin(gaMixin);
Vue.component('DynamicComponent', DynamicComponent);
Vue.mixin(gTagMixin);
Vue.mixin(trackEvent);
smoothscroll.polyfill();

Vue.config.productionTip = false;

new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app');
